import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateVideoPostMutation = createMutationHook(
  MembershipsCreatorApiClient.createVideoPost,
  {
    mutationKey: ['createVideoPost'],
  },
)
